<template>
  <div>
    <div class="item">
      <div class="title">
        {{ $t('okr.list.superior') }}
      </div>
      <div
        class="content"
        v-html="replaceStr2Html(performanceObjective.superior || $t(`okr.nothing`))"
      />
    </div>
    <div class="item">
      <div class="title">
        {{ $t('okr.list.excellent') }}
      </div>
      <div
        class="content"
        v-html="replaceStr2Html(performanceObjective.excellent || $t(`okr.nothing`))"
      />
    </div>
    <div class="item">
      <div class="title">
        {{ $t('okr.list.target') }}
      </div>
      <div
        class="content"
        v-html="replaceStr2Html(performanceObjective.target || $t(`okr.nothing`))"
      />
    </div>
  </div>
</template>
<script>
import { replaceStr2Html } from '@/utils/line-break'
export default {
  props: {
    performanceObjective: {
      type: Object,
      required: true
    }
  },
  setup () {
    return {
      replaceStr2Html
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  min-width: 200px;
  max-width: 500px;
  & + .item {
    margin-top: 24px;
  }
}
.content {
  margin-top: 8px;
}

.title {
  font-weight: 700;
}
</style>
